module.exports = __webpack_public_path__ + "static/media/new6@2x.42599dd0.png";